// eslint-disable-next-line
import { getCourses } from '@/api/index';

export default {
  namespaced: true,
  state: { /* = data */
    courses: [],
    loading: {
      courses: false,
    },
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    loadCourses({ commit }) {
      commit('setLoading', { courses: true });
      getCourses().then((courses) => {
        commit('setCourses', courses);
        
      }).finally(() => {
        commit('setLoading', { courses: false });
      });
    },

    updateCourse({ state, commit }, course) {
      const courses = [...state.courses.filter((c) => c.course_id !== course.course_id), course];
      commit('setCourses', courses);
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },
    setCourses(state, courses) {
      state.courses = courses;
    },
    addCourse(state, course) {
      state.courses = [...state.courses, course];
    },
  },

};
